import { React, useEffect } from 'react';
import OmniAbout from '../components/OmniPage/OmniAbout';
import Solutions from '../components/OmniPage/Solutions';

export default function Omni() {
  useEffect(() => {
    window.scrollTo(0, 0); // Прокрутка страницы в начало при монтировании компонента
  }, []);
  
  return (
    <div>
      <OmniAbout />
      <Solutions />
    </div>
  )
}
